import {
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";
import { Colors, Typography } from "../../styles";

export type TimeOption = "1w" | "2w" | "1m" | "2m" | "max";

const timeOptions: TimeOption[] = ["1w", "2w", "1m", "2m", "max"];

const Times = ({
  selected,
  setSelected,
  style,
}: {
  selected: TimeOption;
  setSelected: (val: TimeOption) => void;
  style?: ViewStyle;
}) => {
  const Time = ({ time }: { time: TimeOption }) => (
    <TouchableWithoutFeedback onPress={() => setSelected(time)}>
      <View
        style={[styles.time, selected === time && styles.selectedTime, style]}
      >
        <Text
          style={[
            Typography.paragraph,
            styles.text,
            selected === time && styles.selectedText,
          ]}
        >
          {time}
        </Text>
      </View>
    </TouchableWithoutFeedback>
  );

  return (
    <View style={styles.container}>
      {timeOptions.map((time) => (
        <Time time={time} key={`time-${time}`} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    marginBottom: 10,
  },
  time: {
    borderRadius: 5,
    borderColor: Colors.plum500,
    borderWidth: 1,
    paddingHorizontal: 6,
    paddingVertical: 3,
    marginRight: 10,
  },
  selectedTime: {
    borderColor: Colors.white,
  },
  text: {
    ...Typography.paragraph,
    ...Typography.weightMedium,
    textTransform: "uppercase",
    color: Colors.plum300,
  },
  selectedText: {
    color: Colors.white,
  },
});

export default Times;
